import mitt from "mitt";

export type EventUnsavedChangesParams = {
  onConfirm: () => void | Promise<void>;
};

export type EmitterEvents = {
  bodyClick: Event;
  selectContainerOpen: undefined;
  showUnsavedChanges: EventUnsavedChangesParams;
  logoutPrompt: undefined;
  ["modals.setLoading"]: string | null;
  ["modals.add.activity@mounted"]: undefined;
  ["modals.add.news@mounted"]: undefined;
  ["modals.add.meeting@mounted"]: undefined;
  ["modals.add.meal@mounted"]: undefined;
};

const emitter = mitt<EmitterEvents>();

export default emitter;
